module.exports = __webpack_public_path__ + "img/img_yuyue.7ae9c57b.jpg";